import React from 'react'
import './css/Gallery.css'
import Navbar from '../components/Navbar'
import Footer from './../components/Footer'
import ImageLazy from '../components/ImageLazy'
import IFrameLazy from '../components/IFrameLazy'
import { Helmet } from 'react-helmet-async'

import Photo1 from './../assets/gallery/Photo (1).jpeg'
import Photo2 from './../assets/gallery/Photo (10).jpeg'
import Photo3 from './../assets/gallery/Photo (11).jpeg'
import Photo4 from './../assets/gallery/Photo (12).jpeg'
import Photo5 from './../assets/gallery/Photo (13).jpeg'
import Photo6 from './../assets/gallery/Photo (14).jpeg'
import Photo7 from './../assets/gallery/Photo (15).jpeg'
import Photo8 from './../assets/gallery/Photo (16).jpeg'
import Photo9 from './../assets/gallery/Photo (17).jpeg'
import Photo10 from './../assets/gallery/Photo (18).jpeg'
import Photo11 from './../assets/gallery/Photo (19).jpeg'
import Photo12 from './../assets/gallery/Photo (2).jpeg'
import Photo13 from './../assets/gallery/Photo (20).jpeg'
import Photo14 from './../assets/gallery/Photo (21).jpeg'
import Photo15 from './../assets/gallery/Photo (22).jpeg'
import Photo16 from './../assets/gallery/Photo (23).jpeg'
import Photo17 from './../assets/gallery/Photo (24).jpeg'
import Photo18 from './../assets/gallery/Photo (25).jpeg'
import Photo19 from './../assets/gallery/Photo (26).jpeg'
import Photo20 from './../assets/gallery/Photo (27).jpeg'
import Photo21 from './../assets/gallery/Photo (28).jpeg'
import Photo22 from './../assets/gallery/Photo (29).jpeg'
import Photo23 from './../assets/gallery/Photo (3).jpeg'
import Photo24 from './../assets/gallery/Photo (30).jpeg'
import Photo25 from './../assets/gallery/Photo (31).jpeg'
import Photo26 from './../assets/gallery/Photo (32).jpeg'
import Photo27 from './../assets/gallery/Photo (33).jpeg'
import Photo28 from './../assets/gallery/Photo (34).jpeg'
import Photo29 from './../assets/gallery/Photo (4).jpeg'
import Photo30 from './../assets/gallery/Photo (5).jpeg'
import Photo31 from './../assets/gallery/Photo (6).jpeg'
import Photo32 from './../assets/gallery/Photo (7).jpeg'
import Photo33 from './../assets/gallery/Photo (8).jpeg'
import Photo34 from './../assets/gallery/Photo (9).jpeg'

import Image1 from './../assets/gallery/Image 2 (1).jpeg'
import Image2 from './../assets/gallery/Image 2 (10).jpeg'
import Image3 from './../assets/gallery/Image 2 (11).jpeg'
import Image4 from './../assets/gallery/Image 2 (12).jpeg'
import Image5 from './../assets/gallery/Image 2 (13).jpeg'
import Image6 from './../assets/gallery/Image 2 (14).jpeg'
import Image7 from './../assets/gallery/Image 2 (15).jpeg'
import Image8 from './../assets/gallery/Image 2 (16).jpeg'
import Image9 from './../assets/gallery/Image 2 (17).jpeg'
import Image10 from './../assets/gallery/Image 2 (18).jpeg'
import Image11 from './../assets/gallery/Image 2 (19).jpeg'
import Image12 from './../assets/gallery/Image 2 (2).jpeg'
import Image13 from './../assets/gallery/Image 2 (20).jpeg'
import Image14 from './../assets/gallery/Image 2 (21).jpeg'
import Image15 from './../assets/gallery/Image 2 (22).jpeg'
import Image16 from './../assets/gallery/Image 2 (23).jpeg'
import Image17 from './../assets/gallery/Image 2 (24).jpeg'
import Image18 from './../assets/gallery/Image 2 (25).jpeg'
import Image19 from './../assets/gallery/Image 2 (3).jpeg'
import Image20 from './../assets/gallery/Image 2 (4).jpeg'
import Image21 from './../assets/gallery/Image 2 (5).jpeg'
import Image22 from './../assets/gallery/Image 2 (6).jpeg'
import Image23 from './../assets/gallery/Image 2 (7).jpeg'
import Image24 from './../assets/gallery/Image 2 (8).jpeg'
import Image25 from './../assets/gallery/Image 2 (9).jpeg'

function Gallery() {
  return (
    <div className='Gallery'>

      <Helmet>
        <title>Gallery | Plaza Catering Service</title>
        <meta name='description' content='Gallery: Explore the exquisite moments created by Plaza Catering. Witness our exceptional catering and event management services come to life.' />
        <link rel='canonical' href='/gallery' />
      </Helmet>

      <div className='overlay'></div>
      <Navbar className='navbar' bgColor={"var(--maroon)"}/>
      <div className='PhotoGallery'>
        <IFrameLazy horizontal={false} hash={'L7M$ev?_00y;00K+t-+Y0G0PQ+=|'} src="https://www.youtube.com/embed/5V4Ohr4wLU4" />
        <IFrameLazy horizontal={false} hash={'L3Hw#*0Ep58w*J3.00[p0731_,01'} src="https://www.youtube.com/embed/r8w9-c-PRVg" />
        
        <IFrameLazy horizontal={false} hash={'LFIq$0oh4:-T00E0ozWF_Nx^xtoI'} src="https://www.veed.io/embed/a60a4876-dc57-4ec5-92e3-eca0c511f267" />
        <IFrameLazy horizontal={false} hash={'LHJiR-~BOrJ8Q.xGtRS#9a$jkBxZ'} src="https://www.veed.io/embed/0e197ea3-576a-4584-98fa-5d26f99a476a" />
        <IFrameLazy horizontal={false} hash={'L39tAX57RQDh1%~qv}E2004m%g~p'} src="https://www.veed.io/embed/cf3c3fb3-60c3-428d-884f-9bc7149cf96c" />
        <IFrameLazy horizontal={false} hash={'LFIq$0oh4:-T00E0ozWF_Nx^xtoI'} src="https://www.veed.io/embed/d1a8655d-5bb7-44a2-8324-68ee385f4f14" />
        <IFrameLazy horizontal={false} hash={'LHJiR-~BOrJ8Q.xGtRS#9a$jkBxZ'} src="https://www.veed.io/embed/83ed6176-260f-423e-8638-ce4d6488f6d0" />
        <IFrameLazy horizontal={true} hash={'L39tAX57RQDh1%~qv}E2004m%g~p'} src="https://www.veed.io/embed/12dbec55-a8ad-4d86-9cc7-c1bd6cd7b864" />
        <IFrameLazy horizontal={false} hash={'LFIq$0oh4:-T00E0ozWF_Nx^xtoI'} src="https://www.veed.io/embed/54dccce2-16aa-4c4d-abd0-9a6f0cd5c09f" />
        <IFrameLazy horizontal={false} hash={'LNG8=VkDRkRkRRobM|WD0Kj[r@WC'} src="https://www.veed.io/embed/b034579d-70b1-4ad2-bea0-e6cd4f2c4cd5" />
        <IFrameLazy horizontal={false} hash={'L39tAX57RQDh1%~qv}E2004m%g~p'} src="https://www.veed.io/embed/bfb063da-796d-41b5-af84-7054f853ce79" />
        <IFrameLazy horizontal={true} hash={'LFIq$0oh4:-T00E0ozWF_Nx^xtoI'} src="https://www.veed.io/embed/fd3a30b0-360f-47ff-b177-0998998c140a" />
        <IFrameLazy horizontal={false} hash={'LNG8=VkDRkRkRRobM|WD0Kj[r@WC'} src="https://www.veed.io/embed/0e607704-f929-432c-9627-f0fa8b74bc97" />
        <IFrameLazy horizontal={false} hash={'L39tAX57RQDh1%~qv}E2004m%g~p'} src="https://www.veed.io/embed/41ee9819-c34b-4ca8-ac2c-d39050a80e6e" />
        <IFrameLazy horizontal={false} hash={'LFIq$0oh4:-T00E0ozWF_Nx^xtoI'} src="https://www.veed.io/embed/e35a33b6-3310-4b50-af87-c88ba2dbc7d4" />
        <IFrameLazy horizontal={false} hash={'L39tAX57RQDh1%~qv}E2004m%g~p'} src="https://www.veed.io/embed/7e581e27-4149-41a3-a837-34bcad8bd60c" />
        <IFrameLazy horizontal={false} hash={'LNG8=VkDRkRkRRobM|WD0Kj[r@WC'} src="https://www.veed.io/embed/a4d208b2-c6c6-48fa-9981-b72818e899e2" />

        <ImageLazy src={Photo1} hash={'LKIW}txsV@R6?]j[j[Szn4t7o3V['} aspect={0.76}/>
        <ImageLazy src={Photo2} hash={'LBG713FDDj=t:zABAI%20xM~ozxt'} aspect={1.0}/>
        <ImageLazy src={Photo3} hash={'LeHnsUoLxDR*~UkCn~WCM|WVj[oJ'} aspect={1.28}/>
        <ImageLazy src={Photo4} hash={'LNG8=VkDRkRkRRobM|WD0Kj[r@WC'} aspect={1.78}/>
        <ImageLazy src={Photo5} hash={'LCAbF:VtOlI:BSNGxHjZ0_xZr_t4'} aspect={0.75}/>
        <ImageLazy src={Photo6} hash={'LZCsH%NFkXt8.TV@o#ozO[sSt7t7'} aspect={2.16}/>
        <ImageLazy src={Photo7} hash={'LYH1s4M.NYkD~pD*slsoo=IVofW;'} aspect={0.83}/>
        <ImageLazy src={Photo8} hash={'LRIMfZj?b]WCcDWCr?WV0hayM|oe'} aspect={0.67}/>
        <ImageLazy src={Photo9} hash={'LPH.E2xa9a%M.TxvRPs:s-oftRR*'} aspect={0.67}/>
        <ImageLazy src={Photo10} hash={'LWK-qJ9FoLD%_ND%tRE0IAj@%2ax'} aspect={0.67}/>
        <ImageLazy src={Photo11} hash={'LHE2qP%1ELe:01R*E2Rj9aM|%Mxu'} aspect={0.67}/>
        <ImageLazy src={Photo12} hash={'LFFr680N0e-;9G^*-pIU4q%0%Laf'} aspect={0.67}/>
        <ImageLazy src={Photo13} hash={'LTIoz;^kbvOW2?T0o#xG^5SgK3bY'} aspect={1.34}/>
        <ImageLazy src={Photo14} hash={'LPGQawI;O9r?F_rrRkSP14$yr?Si'} aspect={0.67}/>
        <ImageLazy src={Photo15} hash={'LGGjW[oyi_tR~pxtWAbvKPSNs:WB'} aspect={1.33}/>
        <ImageLazy src={Photo16} hash={'LyMH0]M{WVR*~qjZWBs:jYt7WBay'} aspect={0.67}/>
        <ImageLazy src={Photo17} hash={'LCDuPGxZ0$R-NH%1W.n*0iWB-UR+'} aspect={0.67}/>
        <ImageLazy src={Photo18} hash={'LlMt5Mof?vRj_Nayx]ofM|RjWAoz'} aspect={0.67}/>
        <ImageLazy src={Photo19} hash={'LNGk]~x^?cs$x|tS%N$wNOIpx[ad'} aspect={0.67}/>
        <ImageLazy src={Photo20} hash={'LIE.%^t8E1M__3jYofRk00IUxuxv'} aspect={0.67}/>
        <ImageLazy src={Photo21} hash={'LHGbIxxZ4:xu~ot6Rjt74.jr%LRj'} aspect={0.67}/>
        <ImageLazy src={Photo22} hash={'LJG8P}%gn}9GTM?G%1E2~V?GR*WU'} aspect={0.67}/>
        <ImageLazy src={Photo23} hash={'L59i;.#rh063JUS0v#+_~WNx$%,@'} aspect={1.0}/>
        <ImageLazy src={Photo24} hash={'LJEB]BIWIp%L5rt6s-WC0NofodWA'} aspect={0.67}/>
        <ImageLazy src={Photo25} hash={'LKKTxi_30KD*9FRj-;xuD*D*NGt7'} aspect={0.67}/>
        <ImageLazy src={Photo26} hash={'LfF=aJt80MWqfjt7ozR+4:ay?GjZ'} aspect={0.67}/>
        <ImageLazy src={Photo27} hash={'LIG[yRRjIURj~pWBRkj[S6fkofax'} aspect={1.5}/>
        <ImageLazy src={Photo28} hash={'LOIN%At8pHoL~pxttPt7.SbcRQju'} aspect={0.67}/>
        <ImageLazy src={Photo29} hash={'L99jlv-;XVW=8_WFMwWA0LI9xuj]'} aspect={1.5}/>
        <ImageLazy src={Photo30} hash={'L@Kne;RjoLjs~qofazofj]a|ofay'} aspect={1.5}/>
        <ImageLazy src={Photo31} hash={'LHKKWUD%NGRi_NIVxuRjIARj%Lxu'} aspect={0.67}/>
        <ImageLazy src={Photo32} hash={'LFDc2OxZ9HxZ4:ofxtj]0LRk%1bI'} aspect={0.67}/>
        <ImageLazy src={Photo33} hash={'LcHeB,jbxDNa~Wt7s9R*ogR+s,oI'} aspect={0.82}/>
        <ImageLazy src={Photo34} hash={'LVFWnQS#0#R+v$WUSzayS1w|N_ju'} aspect={0.67}/>

        <ImageLazy src={Image1} hash={'L6E2j~Oms=NePS57IW01II^kog9a'} aspect={1.33}/>
        <ImageLazy src={Image2} hash={'LKIN?QWApIai_3M_adxt0iMxw[oz'} aspect={0.67}/>
        <ImageLazy src={Image3} hash={'LFG*~6%1D*slMvxsNHof00f5xaRj'} aspect={0.67}/>
        <ImageLazy src={Image4} hash={'L6DIk2NEK5S%_29E~W0eVXt8~W9F'} aspect={1.5}/>
        <ImageLazy src={Image5} hash={'LRCQ42.T%g?b%MR%j@xuM{%2%Mt8'} aspect={0.67}/>
        <ImageLazy src={Image6} hash={'LNHxjE4;00%L_3x^V@8_-;%MRjRi'} aspect={0.67}/>
        <ImageLazy src={Image7} hash={'LjNT%o-;M{xu~pt7RjoKx[axj[j]'} aspect={0.67}/>
        <ImageLazy src={Image8} hash={'LHDJhmIU4UITM|tRDhjbH{M_.8M_'} aspect={0.67}/>
        <ImageLazy src={Image9} hash={'LaIXQ*Diozs;~pVsxZxaxuRnRjt7'} aspect={0.67}/>
        <ImageLazy src={Image10} hash={'LCDuPGxZ0$R-NH%1W.n*0iWB-UR+'} aspect={0.67}/>
        <ImageLazy src={Image11} hash={'LBINNn_3~VWCROWA9uD*^-T0tPNH'} aspect={0.67}/>
        <ImageLazy src={Image12} hash={'L57vokZ+1]6{9]-UaLoL1dJQ=d#B'} aspect={0.67}/>
        <ImageLazy src={Image13} hash={'LBELm59F9JNK0gxuaI%19jRjXOoz'} aspect={0.67}/>
        <ImageLazy src={Image14} hash={'LBExO,tR56-n%%rr9EE2BZ%2v{WB'} aspect={0.67}/>
        <ImageLazy src={Image15} hash={'LVF#jyo#0fWU%MkWjrRj9vbcxZoJ'} aspect={0.67}/>
        <ImageLazy src={Image16} hash={'LUJ@?*^+S5Mx%g~qIUWCNIIUa#WA'} aspect={1.5}/>
        <ImageLazy src={Image17} hash={'L9E_?P0MRi_L%e~CIoIA?aE3M{%M'} aspect={0.67}/>
        <ImageLazy src={Image18} hash={'LHG*yP?G0LE2.8s,IVR*?DR+R+M|'} aspect={0.67}/>
        <ImageLazy src={Image19} hash={'LGG@hyBTI;xFt+10MzS5E4v$IC?E'} aspect={1.36}/>
        <ImageLazy src={Image20} hash={'LAH-*]=r8^o~MvMxTfWBmiMd?HR-'} aspect={1.34}/>
        <ImageLazy src={Image21} hash={'LVIOFCM{4-ogDNkCx^WA%NaeWVjs'} aspect={0.75}/>
        <ImageLazy src={Image22} hash={'LIMY[#NH0Lx]*0S5wHW;0mtSI]nN'} aspect={1.5}/>
        <ImageLazy src={Image23} hash={'LIDm7zVt04f*XRX6RksCEMWC-UR*'} aspect={0.67}/>
        <ImageLazy src={Image24} hash={'LlK]v6oIXNbaUHw^$fs.-WWVg0bH'} aspect={0.75}/>
        <ImageLazy src={Image25} hash={'LDDcgBs74q0MRr4;-.M{D,t8xYen'} aspect={0.67}/>

      </div>
      <Footer />
    </div>
  )
}

export default Gallery